import { defineComponent as _defineComponent } from 'vue'
import type { Registration } from '@/types/Registration';
import type { Seat } from '@/types/Seat';
import { required, maxLength, email, helpers, minLength } from '@vuelidate/validators';
import { computed, reactive, nextTick, ref } from 'vue';
import type { PropType } from 'vue';
import useValidate from '@vuelidate/core'
import { formatPhone, invalidPhoneMsg, maxLengthMsg, minLengthMsg, phoneValidator, requiredMsg } from '@/validation/validationHelpers';
import { settings } from '@/services/Storage'


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketsRegistrationAdd',
  props: {
  seats: {
    required: true,
    type: Array as PropType<Seat[]>
  }
},
  emits: ['cancel', 'save'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props


const reg = reactive<Registration>({
  registrationId: '',
  gameId: '',
  firstname: settings.firstName,
  lastname: settings.lastName,
  phone: settings.phoneNumber,
  email: settings.email,
  notes: ''
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars


const seatId = ref('')


const rules = computed(() => {
  return {
    firstname: {
      required: helpers.withMessage(requiredMsg, required),
      minLength: helpers.withMessage(minLengthMsg, minLength(2))
    },
    lastname: {
      required: helpers.withMessage(requiredMsg, required),
      minLength: helpers.withMessage(minLengthMsg, minLength(3))
    },
    phone: { 
      required: helpers.withMessage(requiredMsg, required),
      phone: helpers.withMessage(invalidPhoneMsg, phoneValidator)
    },
    email: {
      email,
      minLength: helpers.withMessage(minLengthMsg, minLength(7))
    },
    notes: {
      maxLength: helpers.withMessage(maxLengthMsg, maxLength(200))
    }
  }
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const v$ = useValidate(rules, reg, { $autoDirty: true })

// eslint-disable-next-line @typescript-eslint/no-unused-vars


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const format = () => {
  nextTick(() => {
    if (v$.value.phone.$error) {
      return
    }
    const phone = formatPhone(reg.phone)
    if (phone) {
      reg.phone = phone
    }
  })
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const save = async () => {
  settings.firstName = reg.firstname
  settings.lastName = reg.lastname
  settings.phoneNumber = reg.phone
  settings.email = reg.email
  emit('save', reg, seatId.value)
}


const __returned__ = { reg, props, seatId, rules, v$, emit, format, save, required, maxLength, email, helpers, minLength, computed, reactive, nextTick, ref, useValidate, formatPhone, invalidPhoneMsg, maxLengthMsg, minLengthMsg, phoneValidator, requiredMsg, settings }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})